import {
  createContext,
  useContext,
  useState,
  useMemo,
  memo,
  ReactNode,
} from "react";

const ModelDetailsContext = createContext<any>(null);
export const useModelDetailsContext = () => useContext(ModelDetailsContext);

const ModelDetailsProvider = ({ children }: { children: ReactNode }) => {
    const [modelGenerateContextData, setModelGenerateContextData] = useState<any>([]);
    const [isGenerateModelContextOpen, setIsGenerateModelContextOpen] = useState<boolean>(false);
    const [isPendingStatusModalOpen, setIsPendingStatusModalOpen] = useState(false);

    const handleBlur = (e: React.FocusEvent<HTMLDivElement>, key: any) => {
        const editedContent = e.target.textContent;
        const updatedContextValue = modelGenerateContextData?.map((item: any) => {
          if (item.col_key === key) {
              return {
                  ...item,
                  label: editedContent
              };
          }
          return item;
      });
      setModelGenerateContextData(updatedContextValue);
    }

  const contextValue = useMemo(
    () => ({
        modelGenerateContextData,
        setModelGenerateContextData,
        isGenerateModelContextOpen,
        setIsGenerateModelContextOpen,
        isPendingStatusModalOpen,
        setIsPendingStatusModalOpen,
        handleBlur,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modelGenerateContextData, isGenerateModelContextOpen, isPendingStatusModalOpen]
  );

  return (
    <ModelDetailsContext.Provider value={contextValue}>
      {children}
    </ModelDetailsContext.Provider>
  );
};

export default memo(ModelDetailsProvider);